var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4999 58.6667C47.1666 58.6667 59.1666 46.6667 59.1666 32C59.1666 17.3333 47.1666 5.33334 32.4999 5.33334C17.8333 5.33334 5.83325 17.3333 5.83325 32C5.83325 46.6667 17.8333 58.6667 32.4999 58.6667Z",
    fill: "#009E10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 32L28.7134 39.5467L43.8334 24.4533",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailConfirmed);
export default __webpack_public_path__ + "static/media/emailConfirmed.905c8af12899372220172bcced2440b3.svg";
export { ForwardRef as ReactComponent };